<template>
  <figure>
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsTravelsCumulativeEmissions.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'TravelsCumulativeEmissions',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    options: function () {
      let allEmissions = {}
      for (let travel of this.ghgi.travels) {
        for (let section of travel.sections) {
          for (let name of travel.names) {
            let intensity = section.intensity.intensity
            if (name in allEmissions) {
              allEmissions[name] += intensity
            } else {
              allEmissions[name] = intensity
            }
          }
        }
      }
      const cumulativeSum = ((sum) => (value) => {
        sum += value
        return sum
      })(0)
      // sort by decreasing order of emissions
      allEmissions = Object.keys(allEmissions)
        .map(function (k) {
          return parseFloat(allEmissions[k])
        })
        .sort(function (a, b) {
          return b - a
        })
      allEmissions = allEmissions.map(cumulativeSum)
      let total = allEmissions[allEmissions.length - 1]

      let [twentyPerc, fiftyPerc, seventyPerc] = [0, 0, 0]
      for (let emission of allEmissions) {
        let cPerc = (emission / total) * 100
        if (cPerc >= 50) {
          break
        }
        if (fiftyPerc < cPerc) {
          fiftyPerc = cPerc
        }
      }
      for (let emission of allEmissions) {
        let cPerc = (emission / total) * 100
        if (cPerc >= 25) {
          break
        }
        if (twentyPerc < cPerc) {
          twentyPerc = cPerc
        }
      }
      for (let emission of allEmissions) {
        let cPerc = (emission / total) * 100
        if (cPerc >= 75) {
          break
        }
        if (seventyPerc < cPerc) {
          seventyPerc = cPerc
        }
      }

      allEmissions = allEmissions.map(function (val) {
        let y = (val / total) * 100
        let color = null
        if (y === fiftyPerc) {
          color = 'red'
        } else if (y === twentyPerc) {
          color = 'red'
        } else if (y === seventyPerc) {
          color = 'red'
        }
        return {
          y: y,
          color: color
        }
      })
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: Array.from(Array(allEmissions.length).keys()).map(
            (val) => val + 1
          )
        },
        tooltip: {
          headerFormat:
            '<b>{point.key}</b> ' +
            this.$t('compGraphicsTravelsCumulativeEmissions.label-2'),
          pointFormat:
            ' <b>{point.y}</b>' +
            this.$t('compGraphicsTravelsCumulativeEmissions.label-1'),
          valueDecimals: 2
        },
        yAxis: {
          max: 100,
          tickInterval: 10,
          title: {
            text: this.$t('compGraphicsTravelsCumulativeEmissions.label-1')
          },
          plotLines: [
            {
              value: 25,
              color: 'red',
              width: 1,
              dashStyle: 'ShortDash',
              zIndex: 10
            },
            {
              value: 50,
              color: 'red',
              width: 1,
              dashStyle: 'ShortDash',
              zIndex: 10
            },
            {
              value: 75,
              color: 'red',
              width: 1,
              dashStyle: 'ShortDash',
              zIndex: 10
            }
          ]
        },
        series: [
          {
            data: allEmissions,
            zIndex: 0
          }
        ],
        plotOptions: {
          series: {
            // https://api.highcharts.com/highcharts/plotOptions.series.turboThreshold
            turboThreshold: 10000
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
